import {Steps} from "antd";
import {useCreateKycContext} from "../../context/create-kyc";
import type {CreateKycSteps as CreateKycStepsType} from "../../reducers/create-kyc/types";

export function CreateKycSteps() {
  const {state} = useCreateKycContext();
  const mapStepToNumber: Record<CreateKycStepsType, number> = {
    basicForm: 0,
    documentUpload: 1,
  };

  return (
    <div>
      <Steps
        // onChange={onStepChange}
        current={mapStepToNumber[state.currentCreateKycStep]}
        size="small"
        // direction="vertical"
      >
        <Steps.Step title="Basic details" />
        <Steps.Step
          title="Upload documents"
          disabled={state.currentCreateKycStep === "basicForm"}
        />
      </Steps>
    </div>
  );
}
